async function supportShowAnimation(popover, isPolyfill) {
  const { transitionDuration } = getComputedStyle(popover);
  async function delay(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }
  const delayTime = isPolyfill ? 10 : 5;
  if (transitionDuration !== "0s")
    await delay(delayTime);
  popover.classList.add("popover-showing");
  popover.classList.remove("popover-closing");
  popover.dataset.open = "";
  popover.removeAttribute("data-closing");
  popover.removeAttribute("data-closed");
}
function supportClosingAnimation(popover) {
  popover.classList.remove("popover-showing");
  popover.classList.add("popover-closing");
  popover.dataset.closing = "";
  const { animationDuration, transitionDuration } = getComputedStyle(popover);
  const runAnimationEnd = () => {
    popover.classList.remove("popover-closing");
    popover.removeAttribute("data-closing");
    popover.dataset.closed = "";
  };
  const runTransitionEnd = () => {
    popover.classList.remove("popover-closing");
    popover.removeAttribute("data-closing");
    popover.dataset.closed = "";
  };
  if (animationDuration !== "0s")
    popover.addEventListener("animationend", runAnimationEnd, {
      once: true
    });
  else if (transitionDuration !== "0s")
    popover.addEventListener("transitionend", runTransitionEnd, {
      once: true
    });
  else {
    popover.classList.remove("popover-closing");
    popover.removeAttribute("data-closing");
    popover.dataset.closed = "";
  }
}
export {
  supportClosingAnimation,
  supportShowAnimation
};
